<template>
  <div id="page-alldemands" class="d-flex">
    <MainBarMenuV2 />
    <div class="header-top">
      <div class="container-fluid">
        <HeadingUser />
      </div>
    </div>
    <div class="layout-content container-fluid div1 mt-5">
      <div class="row mt-5 mt-md-5">
        <div class="col-12 col-md-12">
          <div class="row">
            <div class="col-sm-5">
              <b-container>
                <b-row>
                  <b-col class="fluid p-0 mx-1">
                    <label class="info-title1">
                      Aquí puedes consultar el estado de tus propinas del día de
                      hoy o de días anteriores.</label>
                    <!--h1> A {{this.activeBtn}} </h1-->
                  </b-col>
                  <b-col md="1"></b-col>
                </b-row>
              </b-container>
              <!-- Datapicker-->
            </div>
          </div>

          <div class="row">
            <div class="col-sm-5 max-content">
              <div class="col-9 p-3 mb-5" align="left">
                <b-container class="max-content">
                  <b-row>
                    <b-col class="fluid p-0 shadow" style="border-radius: 8px">
                      <vc-calendar @dayclick="viewDay" is-expanded :max-date="new Date()" :attributes="attributes"
                        show-caps />
                    </b-col>
                    <b-col md="3"></b-col>
                  </b-row>
                </b-container>
              </div>
              <div class="col-11">
                <b-container class="max-content">
                  <b-row class="mb-3 p-0">
                    <b-col class="ml-auto p-0"><label class="info-title1">Avance de propinas</label></b-col>
                  </b-row>
                  <b-row class="mb-4 p-0">
                    <b-col class="mb-0 p-0">
                      <div class="content-toggle">
                        <div class="toggle-search">

                          <button type="button" name="btnSemAct" class="btn_optionlogin" @click="activeBtnSA"
                            :class="{ bn_active: activeBtn === 'Semana actual' }">

                            <span class="cta ml-0"> Semana selec.</span>

                          </button>

                          <button type="button" name="btnmesactual" class="btn_optionlogin" @click="activeBtnMA"
                            :class="{ bn_active: activeBtn === 'Mes actual' }">
                            <span class="cta"> Mes de {{ this.mes_abr }}</span>
                          </button>

                          <button type="button" name="btnyearactual" class="btn_optionlogin" @click="activeBtnYA"
                            :class="{ bn_active: activeBtn === 'Year actual' }">
                            <span class="cta"> Año {{ this.year }}</span>
                          </button>
                        </div>
                      </div>

                      <!--button
                        width="132px"
                        name="btnSemAct"
                        class="ml-0 p-3 bn_fecha"
                        @click="activeBtnSA"
                        :class="{ bn_active: activeBtn === 'Semana actual' }"
                      >
                        Semana selec.
                      </button>
                      <button
                        width="115px"
                        name=""
                        class="ml-1 p-3 bn_fecha"
                        @click="activeBtnMA" 
                        :class="{ bn_active: activeBtn === 'Mes actual' }"
                      >
                        Mes de {{this.mes_abr}}
                      </button>
                      <button
                        width="95px"
                        name=""
                        class="ml-1 p-3 bn_fecha"
                        @click="activeBtnYA"
                        :class="{ bn_active: activeBtn === 'Year actual' }"
                      >
                        Año {{this.year}}
                      </button-->
                    </b-col>
                  </b-row>
                  <b-row class="mb-0 p-0 info-card3" v-if="activeBtn == 'Semana actual' && !loading">

                    <b-col class="ml-0 p-3">
                      <b-row class="mb-1 p-1" v-for="i in  setdatas.length" :key="i">
                        <b-col class="md-6 ml-3 p-0"><label class="info_ava_pro"> {{ setdatas[i - 1].date }}

                          </label></b-col>
                        <b-col class="md-4 ml-0 pt-2 pl-5 pr-5">
                          <b-progress :value="setdatas[i - 1].percentage" :max="max" variant="primary"></b-progress>
                        </b-col>
                        <b-col class="md-2 ml-0 pr-4 text-right"><label class="info_ava_pro">$ {{
                            setdatas[i - 1].close_value.toLocaleString('de-DE', { style: 'decimal', decimal: '2' })
                        }}
                          </label></b-col>

                      </b-row>
                    </b-col>
                  </b-row>

                  <b-row class="mb-0 p-0 " v-else-if="loading" role="status">
                    <b-col class=" p-0">
                      <img class="spinner-logo" src="../../assets/images/login/master_isotipo_VP.svg"
                        style="margin:auto;width:20px; height:20px;" alt="logo" />
                      <span class="sr-only">Loading...</span>
                    </b-col>
                  </b-row>



                  <b-row class="mb-0 p-0 info-card3" v-if="activeBtn == 'Mes actual' && !loading">
                    <b-col class="ml-0 p-3">
                      <b-row class="mb-1 p-1" v-for="i in  setdatas.length" :key="i">
                        <b-col class="md-6 ml-3 p-0"><label class="info_ava_pro"> {{ setdatas[i - 1].date }}
                          </label></b-col>
                        <b-col class="md-4 ml-0 pt-2 pl-5 pr-5">
                          <b-progress :value="setdatas[i - 1].percentage" :max="max" variant="primary"></b-progress>
                        </b-col>
                        <b-col class="md-2 ml-0 pr-4 text-right"><label class="info_ava_pro">$ {{
                            setdatas[i - 1].close_value.toLocaleString('de-DE', { style: 'decimal', decimal: '2' })
                        }}
                          </label></b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <!--b-row
                    class="mb-0 p-0 info-card3"
                    v-else-if="loading"  role="status"
                  >
                    <b-col class="md-12 ml-5 p-0"> 
                      <span class="sr-only">Loading...</span>
                    </b-col>
                </b-row-->

                  <b-row class="mb-0 p-0 info-card3" v-if="activeBtn == 'Year actual' && !loading">
                    <b-col class="ml-1 p-3">
                      <b-row class="mb-1 p-1" v-for="i in setdatas.length" :key="i">
                        <b-col class="md-6 ml-3 p-0"><label class="info_ava_pro">{{ setdatas[i - 1].month }}
                          </label></b-col>
                        <b-col class="md-4 ml-0 pt-2 pl-5 pr-5">
                          <b-progress :value="setdatas[i - 1].percentage" :max="max" variant="primary"></b-progress>
                        </b-col>
                        <b-col class="md-2 ml-0 pr-4 text-right"><label class="info_ava_pro">$ {{
                            setdatas[i - 1].close_value.toLocaleString('de-DE', { style: 'decimal', decimal: '2' })
                        }}
                          </label></b-col>
                      </b-row>
                    </b-col>
                  </b-row>
                  <!--b-row
                    class="mb-0 p-0 info-card3"
                    v-else-if="loading"  role="status"
                  >
                    <b-col class="md-12 ml-5 p-0"> 
                      <span class="sr-only">Loading...</span>
                    </b-col>
                </b-row-->
                </b-container>
              </div>
            </div>

            <div class="col-sm-7 p-3">
              <b-container fluid class="text-left shadow" style="border-radius: 8px">
                <b-row class="mb-0" style="
                    border-top-left-radius: 8px;
                    border-top-right-radius: 8px;
                  ">
                  <b-col md="0" class="p-3"> <img style="margin: auto" src="../../assets/images/icons/icon-money.svg" />
                  </b-col>
                  <b-col class="p-3"><label style="
                        font-size: 16px;
                        font-weight: bold;
                      ">Reporte de propinas de {{ this.mes }}</label>

                  </b-col>
                </b-row>

                <b-row class="mb-5 info-card" style="
                    border-bottom-left-radius: 8px;
                    border-bottom-right-radius: 8px;
                  ">
                  <b-col md="9" class="ml-md-auto p-3"><label class="info_ava_pro">Tienes <b>{{ this.days_worked }}
                        días</b> reportados y tu consolidado es: </label></b-col>
                  <b-col md="3" class="ml-md-auto p-3 text-right">

                    <label v-if="!loading" class="Cta" style="color: #5d5fef">

                      $ {{ this.close_value.toLocaleString('de-DE', { style: 'decimal', decimal: '2' }) }}</label>
                    <label v-else-if="loading" role="status"> <img class="spinner-logo"
                        src="../../assets/images/login/master_isotipo_VP.svg"
                        style="margin:auto;width:20px; height:20px;" alt="logo" />
                    </label>
                  </b-col>
                </b-row>
              </b-container>

              <b-container fluid class="text-left shadow-sm info-card2" v-if="false">
                <b-row class="mb-5 info-card2">
                  <b-col md="0" class="p-3"><img class="icon_info"
                      src="../../assets/images/icons/info_24px_rounded.png" /></b-col>
                  <b-col class="p-3"><label class="info_ava_pro"><b>Recuerda que si tu consolidado total de propinas
                        excede
                        el 40% de tu salario recibido a fin de mes, se te
                        descontará 7% para el aporte de tus cesantías.</b></label></b-col>
                </b-row>
              </b-container>

              <b-container fluid class="dia_ausencia" v-if="Turns == false && hoy == false && !loading">
                <b-row class="mb-7">
                  <b-col class="mx-auto p-3" style="text-align: center"><img class="img_dia_ausente"
                      src="../../assets/images/tipsemployee/dia_ausente.svg" /></b-col>
                </b-row>
                <b-row class="mb-7">
                  <b-col class="mx-auto p-3" style="text-align: center"><label class="info_reporte_text">El día
                      seleccionado tuviste descanso o te ausentaste.
                    </label></b-col>
                </b-row>
              </b-container>
              <b-container class="mb-0 p-0 " v-else-if="loading" role="status"></b-container>

              <b-container fluid class="dia_sin_reporte" v-if="Turns == false && hoy == true && !loading">
                <b-row class="mb-7">
                  <b-col class="mx-auto p-3" style="text-align: center"><img class="img_dia_ausente"
                      src="../../assets/images/tipsemployee/dia_sin_reporte.svg" /></b-col>
                </b-row>
                <b-row class="mb-7">
                  <!--b-col class="mx-auto p-3" style="text-align: center"
                    ><label class="info_reporte_text"
                      >El reporte de turno de este día todavía no se ha
                      realizado por tu Manager. Intenta revisarlo en otro
                      momento.
                    </label></b-col-->
                  <b-col class="mx-auto p-3" style="text-align: center"><label class="info_reporte_text">El reporte de
                      turno no se ha
                      realizado por tu Manager.
                    </label></b-col>
                </b-row>
              </b-container>
              <b-container class="mb-0 p-0 " v-else-if="loading" role="status"></b-container>

              <b-container fluid class="text-left shadow mb-3" style="border-radius: 8px"
                v-if="Turns == true && (this.setdataTurns.status == '1' || this.setdataTurns.status == '2') && !loading">
                <b-row class="mb-2 titulo_detalle_turno">
                  <b-col class="ml-auto p-1"><label class="ml-3 info_reporte_text"><b>Detalle del reporte de
                        turno</b></label></b-col>
                </b-row>
                <b-container fluid class="text-center p-3">
                  <b-row class="mb-1 p-3 shadow-sm text-center info-card" style="
                      background: #eef2fa;
                      border-radius: 8px;
                      display: flex;
                      align-items: center;
                    ">
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"><label class="info_detalle">Punto de
                        venta
                      </label></b-col>
                    <b-col md="4" class="ml-mb-auto p-auto info_border_titulo"><label class="info_detalle"
                        style="text-align: right">Fecha</label></b-col>
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"><label class="info_detalle">Cargo
                      </label></b-col>
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"><label class="info_detalle"
                        style="text-align: right">Puntaje</label></b-col>
                    <b-col md="2" class="ml-mb-auto p-auto"><label class="info_detalle">Propina del día</label></b-col>
                  </b-row>
                  <b-row class="mb-1 p-3 text-center">
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"><label
                        class="info_ava_pro">{{ this.setdataTurns.nombre_pdv }} </label></b-col>
                    <b-col md="4" class="ml-mb-auto p-auto info_border_titulo"><label class="info_ava_pro"
                        style="text-align: right">{{ this.setdataTurns.fecha_turno }}</label></b-col>
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"><label
                        class="info_ava_pro">Mesero</label></b-col>
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"><label class="info_ava_pro"
                        style="text-align: right">{{ this.setdataTurns.puntaje }}</label></b-col>
                    <b-col md="2" class="ml-mb-auto p-auto"><label
                        class="info_ava_pro">${{ this.setdataTurns.propina_dia_colaborador.toLocaleString('de-DE', {
                            style: 'decimal', decimal: '2'
                          })
                        }}</label></b-col>
                  </b-row>

                  <b-row class="mb-3 info-card p-1" style="border-radius: 8px">
                    <b-col md="10" class="ml-md-auto p-3 text-left"><label class="info_ava_pro">Propinas del día del
                        Punto de venta</label></b-col>
                    <b-col md="2" class="ml-md-auto p-3 text-right"><label class="Cta"
                        style="color: #5d5fef">${{ this.setdataTurns.propina_diaria_pdv.toLocaleString('de-DE', {
                            style:
                              'decimal', decimal: '2'
                          })
                        }}</label></b-col>
                  </b-row>

                  <b-row class="mb-3 info-card p-1" style="border-radius: 8px"
                    v-if="Turns == true && this.novedad == true">
                    <b-col md="4" class="ml-mb-auto p-auto info_border_titulo text-left"><label
                        class="info_detalle">Tipo de novedad</label></b-col>
                    <b-col md="8" class="ml-mb-auto p-auto  text-right"><label
                        class="info_ava_pro">{{ this.setdataTurns.tipo_novedad }}</label></b-col>


                  </b-row>


                  <b-row class="text-left info-card2">
                    <b-col md="0" class="p-3"><img class="info_icon"
                        src="../../assets/images/icons/info_24px_rounded.png" /></b-col>
                    <b-col class="p-3"><label class="info_ava_pro"><b>Si tienes dudas con tu reporte de turnos, ponte en
                          contacto con el Mánager encargado de tu Punto de
                          Venta.</b></label></b-col>
                  </b-row>
                </b-container>
              </b-container>

              <b-container class="mb-0 p-0 " v-else-if="loading" role="status"> <img class="spinner-logo"
                  src="../../assets/images/login/master_isotipo_VP.svg" style="margin:auto;width:20px; height:20px;"
                  alt="logo" />
              </b-container>
              <b-container fluid class="text-left shadow mb-3" style="border-radius: 8px" v-if="false">
                <b-row class="mb-2 titulo_detalle_turno">
                  <b-col class="ml-auto p-1"><label class="ml-3" style="
                        font-family: Open Sans;
                        font-size: 16px;
                        color: #1c3a4e;
                      "><b>Detalle de novedad de nómina</b></label></b-col>
                </b-row>
                <b-container fluid class="text-center p-3">
                  <b-row class="mb-1 p-3 shadow-sm text-center" style="
                      background: #eef2fa;
                      border-radius: 8px;
                      display: flex;
                      align-items: center;
                    ">
                    <b-col md="4" class="ml-mb-auto p-auto info_border_titulo"><label class="info_detalle">Tipo de
                        novedad</label></b-col>
                    <b-col md="3" class="ml-mb-auto p-auto info_border_titulo"><label class="info_detalle">Aprobado jefe
                        de zona</label></b-col>
                    <!--b-col md="2" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_detalle">Propina </label></b-col
                    -->
                    <b-col md="3" class="ml-mb-auto p-auto"><label class="info_detalle">Estado de novedad</label>
                    </b-col>
                  </b-row>
                  <b-row class="mb-1 p-3 text-center">
                    <b-col md="4" class="ml-mb-auto p-auto info_border_titulo"><label
                        class="info_ava_pro">{{ this.setdataTurns.tipo_novedad }}</label></b-col>
                    <b-col md="3" class="ml-mb-auto p-auto info_border_titulo"><label class="info_ava_pro"
                        style="text-align: right">-</label></b-col>
                    <!--b-col md="2" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_ava_pro">$--20.000</label></b-col
                    -->
                    <b-col md="3" class="ml-mb-auto p-auto" v-if="confirmado == true"><img style="position: static"
                        src="../../assets/images/tipsemployee/status_report.jpg" />

                    </b-col>
                    <b-col md="3" class="ml-mb-auto p-auto" v-else-if="confirmado == false"><img style="position: static"
                        src="../../assets/images/tipsemployee/status_report_ok.jpg" /></b-col>
                  </b-row>
                </b-container>
              </b-container>

              <!--b-container
                fluid
                class="text-left shadow mb-3"
                style="border-radius: 8px"
              >
                <b-row class="mb-2 titulo_detalle_turno">
                  <b-col class="ml-auto p-1"
                    ><label class="ml-3 info_reporte_text"
                      ><b>Detalle del reporte de turno</b></label
                    ></b-col
                  >
                </b-row>
                <b-container fluid class="text-center p-3">
                  <b-row class="text-left info-card2">
                    <b-col md="0" class="p-3"
                      ><img
                        class="info_icon"
                        src="../../assets/images/icons/info_24px_rounded.png"
                    /></b-col>
                    <b-col class="p-3"
                      ><label class="info_ava_pro"
                        ><b
                          >Si tienes dudas con tu reporte de turnos, ponte en
                          contacto con el Mánager encargado de tu Punto de
                          Venta.</b
                        ></label
                      ></b-col
                    >
                  </b-row>
                </b-container>
              </b-container>

              <b-container
                fluid
                class="text-left shadow mb-3"
                style="border-radius: 8px"
                v-if="false"
              >
                <b-row class="mb-2 titulo_detalle_turno">
                  <b-col class="ml-auto p-1"
                    ><label class="ml-3 info_reporte_text"
                      ><b>Detalle de novedad de nómina</b></label
                    ></b-col
                  >
                </b-row>
                <b-container fluid class="text-center p-3">
                  <b-row
                    class="mb-1 p-3 shadow-sm text-center"
                    style="
                      background: #eef2fa;
                      border-radius: 8px;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <b-col md="4" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_detalle"
                        >Tipo de novedad</label
                      ></b-col
                    >
                    <b-col md="3" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_detalle"
                        >Aprobado jefe de zona</label
                      ></b-col
                    >
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_detalle">Propina </label></b-col
                    >
                    <b-col md="3" class="ml-mb-auto p-auto"
                      ><label class="info_detalle"
                        >Estado de novedad</label
                      ></b-col
                    >
                  </b-row>
                  <b-row class="mb-1 p-3 text-center">
                    <b-col md="4" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_ava_pro">Reemplazo </label></b-col
                    >
                    <b-col md="3" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_ava_pro" style="text-align: right"
                        >David Molina</label
                      ></b-col
                    >
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_ava_pro">-</label></b-col
                    >
                    <b-col md="3" class="ml-mb-auto p-auto"
                      ><img
                        style="position: static"
                        src="../../assets/images/tipsemployee/status_report_ok.jpg"
                    /></b-col>
                  </b-row>
                </b-container>
              </b-container-->

              <!--b-container
                fluid
                class="text-left shadow mb-3"
                style="border-radius: 8px"
              >
                <b-row class="mb-2 titulo_detalle_turno">
                  <b-col class="ml-auto p-1"
                    ><label
                      class="ml-3"
                      style="
                        font-family: Open Sans;
                        font-size: 16px;
                        color: #1c3a4e;
                      "
                      ><b>Detalle del reporte de turno</b></label
                    ></b-col
                  >
                </b-row>
                <b-container fluid class="text-center p-3">
                  <b-row
                    class="mb-1 p-3 shadow-sm text-center"
                    style="
                      background: #eef2fa;
                      border-radius: 8px;
                      display: flex;
                      align-items: center;
                    "
                  >
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_detalle"
                        >Punto de venta
                      </label></b-col
                    >
                    <b-col md="4" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_detalle" style="text-align: right"
                        >Fecha</label
                      ></b-col
                    >
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_detalle">Cargo </label></b-col
                    >
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_detalle" style="text-align: right"
                        >Puntaje</label
                      ></b-col
                    >
                    <b-col md="2" class="ml-mb-auto p-auto"
                      ><label class="info_detalle"
                        >Propina del día</label
                      ></b-col
                    >
                  </b-row>
                  <b-row class="mb-1 p-3 text-center">
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_ava_pro">Andino </label></b-col
                    >
                    <b-col md="4" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_ava_pro" style="text-align: right"
                        >29/04/2021</label
                      ></b-col
                    >
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_ava_pro">Mesero</label></b-col
                    >
                    <b-col md="2" class="ml-mb-auto p-auto info_border_titulo"
                      ><label class="info_ava_pro" style="text-align: right"
                        >1</label
                      ></b-col
                    >
                    <b-col md="2" class="ml-mb-auto p-auto"
                      ><label class="info_ava_pro">$25.001</label></b-col
                    >
                  </b-row>

                  <b-row class="mb-3 info-card p-1" style="border-radius: 8px">
                    <b-col md="10" class="ml-md-auto p-3 text-left"
                      ><label class="info_ava_pro"
                        >Propinas del día del Punto de venta</label
                      ></b-col
                    >
                    <b-col md="2" class="ml-md-auto p-3 text-right"
                      ><label class="info-card__text">$100.000</label></b-col
                    >
                  </b-row>

                  <b-row class="text-left info-card2">
                    <b-col md="0" class="p-3"
                      ><img
                        class="info_card"
                        src="../../assets/images/icons/info_24px_rounded.png"
                    /></b-col>
                    <b-col class="p-3"
                      ><label class="info_ava_pro"
                        ><b
                          >Si tienes dudas con tu reporte de turnos, ponte en
                          contacto con el Mánager encargado de tu Punto de
                          Venta.</b
                        ></label
                      ></b-col
                    >
                  </b-row>
                </b-container>
              </b-container -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MainBarMenuV2 from "@/components/layouts/MainBarMenuV2.vue";
import HeadingUser from "@/components/user/HeadingUser.vue";
import serverConfig from "./../../services/config";
import { mapActions, mapState } from "vuex";

export default {
  name: "tipsemployee",
  components: {
    MainBarMenuV2,
    HeadingUser,
  },
  data() {
    //let start =  '2021, 9, 1'
    // let  end= '2021, 9, 6'
    // let datos=[]
    //var calendario = '2021, 9, 16'

    return {
      data: [],
      daysWorkedInTheMonth: [],
      money_month: {},
      days_worked: 0,
      close_value: 0,
      Turns: false,
      novedad: false,
      confirmado: false,
      hoy: true,
      date: new Date(),
      mes_abr: "",
      mes: "",
      year: "",
      // calendario:"2021-10-22",
      serverPath: serverConfig.permisosURL,
      isActive: true,
      activeBtn: "Semana actual",
      type_report: 1,
      fecha: new Date(),
      // datalenght:0,
      // setdata:[{date:this.date}],

      error: {
        flag: false,
        class: "", //is-invalid
        message: "",
      },
      fecha_calendario: [],
      attributes: [],

      value: 45,
      max: 100,
    };
  },

  beforeMount() {
    this.activeBtn = "Semana actual";

    let Day = new Date();
    let data1 = {
      date: Day.toISOString().slice(0, 10),
      type_report: this.type_report,
    };

    this.actGetTipsEmployee(data1).then(() => {
      if (this.setdataTurns == null) {
        this.Turns = false;
        this.hoy = true;
        this.novedad = false;
      } else {
        this.Turns = true;
        if (this.setdataTurns.bandera_novedad_turno == 2) this.novedad = true;
        else this.novedad = false;

      }

      if (
        this.setmoney_months != null &&
        this.setmoney_months.close_value !== undefined
      ) {
        this.days_worked = this.setmoney_months.days_worked;
        this.close_value = parseFloat(this.setmoney_months.close_value);

      } else {
        this.days_worked = 0;
        this.close_value = 0;
      }


      this.fecha_calendario = this.setdaysWorkedInTheMonths;

      for (var i = 0; i < this.setdaysWorkedInTheMonths.length; i++) {
        this.fecha_calendario[i] = this.fecha_calendario[i].replace("-", "/");

      }

      this.attributes = [
        {

          highlight: {
            color: "gray",
            fillMode: "solid",
          },
          dates: this.fecha_calendario,
        },
        { dot: "gray", dates: new Date() },
      ];
    });
  },
  mounted() {
    let fecha = new Date();

    const meses = [
      "enero",
      "febrero",
      "marzo",
      "abril",
      "mayo",
      "junio",
      "julio",
      "agosto",
      "septiembre",
      "octubre",
      "noviembre",
      "diciembre",
    ];
    let numeroMes = new Date(fecha).getMonth();
    let nombreMes = "";
    nombreMes = meses[numeroMes];
    this.mes_abr = nombreMes.slice(0, 3);
    this.mes = nombreMes;
    // console.log('fecha para calendario',this.setdaysWorkedInTheMonths);
    var fechayear = fecha.getFullYear();
    this.year = fechayear;
    //this.calendario = "2021,10,27";
    //   console.log('fecha-calendario',this.calendario);
    // console.log('nombre del mes',nombreMes);
    return nombreMes;
  },
  computed: {
    ...mapState("modCore", ["user"]),
    ...mapState("modTipsEmployee", [
      "setmoney_months",
      "setdatas",
      "setdataTurns",
      "setdaysWorkedInTheMonths",
      "loading",
    ]),
  },
  methods: {
    ...mapActions("modTipsEmployee", ["actGetTipsEmployee"]),
    randomValue() {
      this.value = Math.random() * this.max;
    },
    /*onContext(ctx) {
     // this.context = ctx;
    },*/
    activeBtnSA() {
      this.activeBtn = "Semana actual";
      this.type_report = 1;
      this.viewDay({ date: this.fecha });

      // alert(this.activeBtn);
    },
    activeBtnMA() {
      this.activeBtn = "Mes actual";
      this.type_report = 3;
      this.viewDay({ date: this.fecha });
      // this.weeksdays();

      //  alert(this.activeBtn);
    },
    activeBtnYA() {
      this.activeBtn = "Year actual";
      this.type_report = 2;
      this.viewDay({ date: this.fecha });

      //alert(this.activeBtn);
    },

    viewDay(day) {
      //alert(day.date);
      let Today = new Date();
      let Day = new Date(day.date);

      this.fecha = Day.toISOString().slice(0, 10);
      //alert(this.fecha);
      let data1 = {
        date: this.fecha,
        type_report: this.type_report,
      };
      this.actGetTipsEmployee(data1).then(() => {
        if (Today.toISOString().slice(0, 10) == Day.toISOString().slice(0, 10)) this.hoy = true;
        else this.hoy = false;
        if (this.setdataTurns == null) {
          this.Turns = false;
          //this.hoy = true;
          this.novedad = false;
        } else {
          this.Turns = true;
          if (this.setdataTurns.bandera_novedad_turno == 2) {
            this.novedad = true;
            if (this.setdataTurns.status == 2) this.confirmado == true;
            else this.confirmado == false;
          }
          else this.novedad = false;
        }

        if (
          this.setmoney_months != null &&
          this.setmoney_months.close_value !== undefined
        ) {
          this.days_worked = this.setmoney_months.days_worked;
          this.close_value = parseFloat(this.setmoney_months.close_value);
          this.setmoney_months.close_value = 0;
        } else {
          this.days_worked = 0;
          this.close_value = 0;
        }

        //this.setdata=this.setdatas;
        // console.log('datos consultados_mes',this.setmoney_months);
        // console.log('datos consultados_data',this.setdatas);
        // console.log('datos consultados_data_date',this.setdatas[0] );
        //console.log('datos consultados_data_date_total',this.setdatas.length);
        /*    console.log('datos consultados_WMnb',this.setdaysWorkedInTheMonths[0]);
      const fecha_calendario=[];
     */
        for (var i = 0; i < this.setdaysWorkedInTheMonths.length; i++) {
          this.fecha_calendario[i] = this.fecha_calendario[i].replace("-", "/");
        }
        this.attributes = [
          {
            highlight: {
              color: "gray",
              fillMode: "solid",
            },
            dates: this.fecha_calendario,
          },
          { dot: "gray", dates: this.fecha.replace("-", "/") },
        ];
        //}
      });

      const meses = [
        "enero",
        "febrero",
        "marzo",
        "abril",
        "mayo",
        "junio",
        "julio",
        "agosto",
        "septiembre",
        "octubre",
        "noviembre",
        "diciembre",
      ];

      let numeroMes = new Date(this.fecha).getMonth();
      let nombreMes = "";
      nombreMes = meses[numeroMes];
      this.mes_abr = nombreMes.slice(0, 3);
      this.mes = nombreMes;
      // console.log('fecha para calendario',this.setdaysWorkedInTheMonths);

      var fechayear = new Date(this.fecha).getFullYear();
      this.year = fechayear;
    },

    /*  weekday() {
      //Función para obtener los días de la semana en curso
      const fecha = new Date();
      const fechaComoCadena = Date(); // día lunes
      const fechadia = fecha.getDate();
      const dias = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
        "Domingo",
      ];
      var numeroDia = new Date(fechaComoCadena).getDay();
      var nombreDia = [];
      if (numeroDia == 0) {
        numeroDia = 7;
      }
      for (let i = 0; i <= numeroDia; i++) {
        //console.log(numeroDia);
        //console.log(fechadia);
        //console.log(dias[i]);

        if (i > 0 && fechadia + i - numeroDia > 0)
          nombreDia.push(fechadia + i - numeroDia + " " + dias[i]);
      }
      nombreDia = nombreDia.filter(function () {
        return true;
      });
      //console.log(nombreDia);

  

      return nombreDia;



    },*/
    weeksdays() {
      // Función para obtener los días entre semanas del mes en curso
      const fecha = new Date(this.fecha);
      //console.log(fecha);
      var fechadia = fecha.getDate();
      var fechaComoCadena = new Date(); // día lunes
      var fechames = ("0" + (fecha.getMonth() + 1)).slice(-2);
      var fechayear = fecha.getFullYear();
      var diasSemana = [
        "Domingo",
        "Lunes",
        "Martes",
        "Miércoles",
        "Jueves",
        "Viernes",
        "Sábado",
      ];
      var ini = 1;
      var ultimodia = new Date(fecha.getFullYear(), fecha.getMonth() + 1, 0);
      //console.log(ultimodia);
      var fin = ultimodia.getDate();
      fechadia = fin;
      //console.log(`Semana del ${ini} al ${fin} `);
      const dias = [];
      var j = 0;
      dias[j] = ini + " al " + fin;
      var shortDate = "01" + "/" + fechames + "/" + fechayear;
      for (var dia = 1; dia <= fechadia; dia++) {
        shortDate = fechames + "/" + ("0" + dia).slice(-2) + "/" + fechayear;
        //console.log(shortDate);
        fechaComoCadena = new Date(shortDate);
        if (diasSemana[fechaComoCadena.getDay()] == "Domingo") {
          fin = dia;
          dias[j] = ini + "-" + fin;
          j += 1;
          ini = fin + 1;
        } else if (dia == fechadia) {
          fin = dia;
          dias[j] = ini + "-" + fin;
        }
      }
      return dias;
    } /*
    monthday() {
      //Función para obtener los meses del del año hasta el mes en curso

      //const fecha = new Date();
      const fechaComoCadena = Date(); // día lunes
      // const fechames = fecha.getMonth();
      const meses = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      const numeroMes = new Date(fechaComoCadena).getMonth();
      const nombreMes = [];
      for (let i = 0; i <= numeroMes; i++) {
        nombreMes[i] = meses[i];
      }
      return nombreMes;
    },*/,
  },
};
</script>

<style lang="scss" scoped>
.content-toggle {
  /* _tab variants / horizontal */


  /* Auto layout */
  display: flex;
  flex-direction: row;
  align-items: flex-start;

  border: none;
  box-sizing: border-box;


  position: static;
  width: 376px;
  height: 56px;
  left: 28px;
  top: 228px;


  /* Inside auto layout */

  flex: none;
  order: 2;
  flex-grow: 0;
  margin: 30px 0px;


  .Novedades {
    /* Auto layout */

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 2px;

    position: static;
    width: 16px;
    height: 16px;
    left: 128px;
    top: 12px;

    /* highlight/info/medium */

    background: #0075FF;
    border-radius: 100px;
    font-family: 'Ubuntu';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 11px;
    /* identical to box height */

    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;

    /* Inside auto layout */

    flex: none;
    order: 2;
    flex-grow: 0;
    margin: 0px 8px;
  }

  .toggle-search {
    /* Auto layout */

    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 8px;

    position: static;
    left: 0%;
    right: 0%;
    top: 0%;
    bottom: 0%;

    /* CTA/00 */

    background: #ECECFF;
    /* CTA/01 */

    border: 1px solid #C9CAFF;
    box-sizing: border-box;
    border-radius: 48px;

    /* Inside auto layout */

    flex: none;
    order: 0;
    flex-grow: 0;
    margin: 0px 0px;
  }
}

.btn-reporte {
  color: white;
  background-color: transparent;
  border: none;
  padding: 2px 3px;
}

#page-alldemands {
  .data-table {
    tr {
      th {
        &:nth-child(1) {
          min-width: 120px;
        }

        &:nth-child(2) {
          min-width: 170px;
        }

        &:nth-child(3) {
          min-width: 110px;
        }

        &:nth-child(4) {
          min-width: 210px;
        }

        &:nth-child(5) {
          min-width: 110px;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped>
#page-alldemands {
  .cont-search {
    label {
      font-size: 11px;
      color: #454545;
      font-family: Open Sans;
    }

    .cont-input {
      background: #1c3a4e;
      border-radius: 4px;
      padding: 1px;
      width: fit-content;
      float: left;

      .input-text {
        padding: 8px;
        min-width: 160px;
        border-radius: 4px;
        font-style: italic;
        font-weight: 300;
        font-size: 12px;
        color: #bbbbbb;
        border: 0 none;

        &:focus {
          outline: none;
        }
      }

      button {
        background: transparent;
        border: 0 none;
        color: #ffffff;
      }

      @media (min-width: 768px) {
        float: right;
      }
    }
  }

  a:hover,
  a:focus,
  a:active {
    text-decoration: none;
    color: inherit;
  }

  .button1 {
    font-family: "Open Sans";
    background: #e9ecee;
    color: #1c3a4e;
    font-weight: bold;
    //border-radius: 50px;
    height: 32px;
    font-size: 14px;
    text-align: left !important;
    padding-left: 5%;
    padding-right: 5%;
    outline: none;
    border: none;

    &:hover {
      background: darken(#cddce6, 5);
      border: none;
    }
  }

  .div1 {
    border: 0px solid black;
    margin-top: 0px;
    margin-bottom: 0px;
    margin-right: 0px;
    margin-left: 0px;
  }

  .p2 {
    font-family: "Open Sans";
    font-style: normal;
    //font-weight: 600;
    font-size: 14px;
    line-height: 15px;
    color: #454545;
    text-align: left !important;
  }

  .collapsed>.when-opened,
  :not(.collapsed)>.when-closed {
    display: none;
  }

  .centerImg1 {
    width: 16px;
    height: 16px;
    top: 100%;
    float: right;
  }

  .leftImg1 {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }

  /* Center the loader */
  #loader {
    position: absolute;
    left: 50%;
    top: 50%;
    z-index: 1;
    width: 150px;
    height: 150px;
    margin: 85px 0 0 -75px;
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
  }

  @-webkit-keyframes spin {
    0% {
      -webkit-transform: rotate(0deg);
    }

    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }

  /* Add animation to "page content" */
  .animate-bottom {
    position: relative;
    -webkit-animation-name: animatebottom;
    -webkit-animation-duration: 1s;
    animation-name: animatebottom;
    animation-duration: 1s;
  }

  @-webkit-keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0px;
      opacity: 1;
    }
  }

  @keyframes animatebottom {
    from {
      bottom: -100px;
      opacity: 0;
    }

    to {
      bottom: 0;
      opacity: 1;
    }
  }

  #myDiv {
    display: none;
    text-align: center;
  }

  .mycheck {
    vertical-align: middle;
    position: relative;
    bottom: 1px;
  }

  @media only screen and (max-width: 600px) {
    .td2 {
      width: 33%;
    }

    .bn_fecha {
      font-size: 1.2rem;
    }

    .max-content {
      width: max-content;
    }
  }
}

/* Auto Layout */
.bv-layout {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 12px;

  position: static;
  width: 659px;
  height: 56px;
  left: 0px;
  top: 0px;

  /* Neutral / White */

  background: #ffffff;

  /* Inside Auto Layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 0px 0px;
}

.info-card {
  //background-color: #edf9f0;
  background: #ECECFF;
  //border-radius: 8px;
}

.info-card2 {
  background-color: #eef2fa;
  border-radius: 8px;
}

.info-card3 {
  background-color: #f8f8f8;
  border-radius: 8px;
}

.info-card__text {
  font-family: Open Sans;
  font-size: 14px;
  color: #0c9e42;
  text-align: right;
}

.info-title1 {
  /* Header Tablas */

  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #1c3a4e;
}

.bn_fecha {
  background-color: #ffffff;
  border-radius: 100px;
  border: 2px solid #269887;
  color: #269887;
  height: 39px;
  text-align: center;
  justify-content: center;
  align-items: center;
  padding: 16px 24px; //nuevo, opción A
  line-height: 10px;
}

.bn_fecha:hover,
.bn_fecha:active,
.bn_fecha:visited,
.bn_fecha:link,
.bn_fecha:focus,
/*.bn_active {
  background-color: rgba(38, 152, 135, 0.14) !important;
  border-radius: 100px;
  border: 2px solid #269887;
  color: #269887;
}*/
.img_dia_ausente {
  margin-left: auto;
  margin-right: auto;
}

.titulo_detalle_turno {
  background: #f5f5f5;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.info_detalle {
  font-family: Open Sans;
  font-size: 14px;
  color: #000000;
}

.card_header_detalle_turno {
  position: static;
  width: 627px;
  height: 22px;
  left: calc(50% - 627px / 2);
  top: 8px;

  /* Header Tablas */

  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  /* identical to box height */
  color: #1c3a4e;
  /* Inside Auto Layout */
  flex: none;
  order: 0;
  flex-grow: 1;
  margin: 0px 16px;
}

.card_body {
  /* Auto Layout */

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;

  position: static;
  width: 659px;
  height: 269px;
  left: calc(50% - 659px / 2);
  top: calc(50% - 269px / 2 + 19px);

  /* Neutral / White */

  background: #ffffff;

  /* Inside Auto Layout */

  flex: none;
  order: 1;
  align-self: stretch;
  flex-grow: 0;
  margin: 0px 0px;
}

.titulo_puntaje {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 0px;

  position: static;
  width: 627px;
  height: 61px;
  left: 0px;
  top: 0px;

  /* Alert / Info Bg */

  background: #eef2fa;
  border-radius: 8px;

  /* Inside Auto Layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  margin: 0px 0px;
}

.info_ava_pro {
  font-family: Open Sans;
  font-size: 14px;
  color: #454545;
}

.info_icon {
  position: static;
  background: #eef2fa;
  border-radius: 20px;
}

.info_reporte_text {
  font-family: Open Sans;
  font-size: 16px;
  color: #1c3a4e;
}

.info_border_titulo {
  border-right: 1px solid #dddddd;
}
</style>